import React from 'react';
import { Helmet } from 'react-helmet-async';
import PageHeader from '../components/PageHeader';

function FAQ() {
	return (
		<>
			<Helmet>
				<title>FAQ • Appex Connect Hub</title>
				<meta name="description" content="Frequently asked questions about our compliant lead referrals and SMS program." />
			</Helmet>
			<PageHeader title="Frequently Asked Questions" subtitle="Key details about consent, opt-outs, data use, and coverage." />
			<section className="section">
				<div className="container">
				<div className="grid">
					<div className="card" style={{ padding: 18 }}>
						<div className="icon-circle">
							<svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M5 19h14M5 5h14M8 5v14M16 5v14" stroke="currentColor" strokeWidth="1.5"/></svg>
						</div>
						<strong>Are you a lender?</strong>
						<p className="helper">No. We are a marketing and referral service and do not make credit decisions.</p>
					</div>
					<div className="card" style={{ padding: 18 }}>
						<div className="icon-circle">
							<svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M6 8h12v8H6V8Z" stroke="currentColor" strokeWidth="1.5"/><path d="M10 12h4" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/></svg>
						</div>
						<strong>How do I stop messages?</strong>
						<p className="helper">Reply STOP to any message, or submit your number on our Opt-Out page.</p>
					</div>
					<div className="card" style={{ padding: 18 }}>
						<div className="icon-circle">
							<svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M5 11h14v7H5v-7Z" stroke="currentColor" strokeWidth="1.5"/><path d="M9 11V7a3 3 0 0 1 6 0v4" stroke="currentColor" strokeWidth="1.5"/></svg>
						</div>
						<strong>Do you sell my data?</strong>
						<p className="helper">No. We share information with providers solely to fulfill your request.</p>
					</div>
					<div className="card" style={{ padding: 18 }}>
						<div className="icon-circle">
							<svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M7 5h10v14H7V5Z" stroke="currentColor" strokeWidth="1.5"/><path d="M9.5 8.5h5v7h-5v-7Z" stroke="currentColor" strokeWidth="1.5"/></svg>
						</div>
						<strong>What do I consent to?</strong>
						<p className="helper">You consent to receive marketing texts. Message frequency varies; msg/data rates may apply. Consent not required to obtain credit.</p>
					</div>
					<div className="card" style={{ padding: 18 }}>
						<div className="icon-circle">
							<svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M6 5h12v14H6V5Z" stroke="currentColor" strokeWidth="1.5"/><path d="M9 9h6m-6 3h4" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/></svg>
						</div>
						<strong>How is consent tracked?</strong>
						<p className="helper">We store timestamp, method, user agent, and referral URL to evidence consent.</p>
					</div>
					<div className="card" style={{ padding: 18 }}>
						<div className="icon-circle">
							<svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M5 18h14M7 9h10M9 6h6l1 3H8l1-3Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/></svg>
						</div>
						<strong>What industries do you support?</strong>
						<p className="helper">Construction, transportation, healthcare, consumer lending, manufacturing, retail, and energy/solar programs.</p>
					</div>
					<div className="card" style={{ padding: 18 }}>
						<div className="icon-circle">
							<svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M6 8h12v8H6V8Z" stroke="currentColor" strokeWidth="1.5"/><path d="M10 12h4" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/><path d="M8 4h8" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/></svg>
						</div>
						<strong>How fast are opt-outs processed?</strong>
						<p className="helper">Immediately. STOP requests are honored right away and logged internally.</p>
					</div>
				</div>
				</div>
			</section>
		</>
	);
}

export default FAQ;


